<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-form :inline="true" :model="filters">
				<el-form-item label="标题:" label-width="150px" prop="title">
					<el-input v-model="filters.title" auto-complete="off" class="formItem"  size="small"/>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" v-on:click="getGridData">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary"  size="small" @click="addInfo">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="grid_data"  height="calc(100vh - 220px)"  border highlight-current-row v-loading="listLoading" @selection-change="selectGridChange" 
		style="width: 100%;">
			<el-table-column prop="title" label="标题" width="200"></el-table-column>
			<el-table-column prop="picUrl" label="图片路径" width="120">
				<template scope="scope">
					 <div v-html="$util.showPic100(scope.row.picUrl) "></div>
				</template>
			</el-table-column>
			<el-table-column prop="positionCode" label="广告代码" width="100"></el-table-column>
			<el-table-column prop="width" label="宽度" width="90"></el-table-column>
			<el-table-column prop="height" label="高度" width="90"></el-table-column>
			<el-table-column prop="isShow" label="显示" width="150" :formatter="$util.yesOrNo"></el-table-column>
			<el-table-column label="操作" min-width="250">
				<template scope="scope">
					<el-button size="small" @click="editInfo(scope.$index, scope.row)">编辑</el-button>
					<el-button  size="small" @click="delInfo(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<pagination :totalPage="total" :currentPage="filters.page" :pageSize="filters.rows"
			@pageSizeCallBack="handleSizeChange" @currentPageCallBack="handleCurrentChange"></pagination>

		<addsave :showTitle="showTitle" :dialogAddShow="dialogAddShow" :mid="mid" @saveCallBack="saveCallBack" @getVisible="closeDialog"></addsave>
	</section>
</template>
<script>
import pagination from '@/components/common/pagination.vue'
	import addsave from '../basic/advertisementadd.vue'
	export default {
		name:"advertisementList",
		components: {
			addsave,pagination
		},
		data() {
			return {
				filters: {
					title: '',
					rows: 10,
					page: 1
				},
				grid_data: [],
				total: 0,
				listLoading: false,
				sels: [], //列表选中列
				showTitle: "",
				dialogAddShow: false,
				mid: 0
			}
		},
		methods: {

			handleSizeChange(val) {
				this.filters.rows = val;
				this.getGridData();
			},
			handleCurrentChange(val) {
				this.filters.page = val;
				this.getGridData();
			},
			//获取列表
			getGridData() {
				this.listLoading = true;
				let formData = this.$util.jsonToForm(this.filters);
				this.$axios.post("/basic/getadvertisementlist", formData).then(res => {
					this.listLoading = false;
					this.total = res.data.total;
					this.grid_data = res.data.data;
				});
			},
			//删除
			delInfo: function(index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					let formData = new FormData();
					formData.append("id", row.id);
					this.$axios.post("/basic/advertisementdel", formData).then(res => {
						if (res.data.status == 0) {
							this.$message("删除成功!");
							this.getGridData();
						} else {
							this.$message(res.data.msg);
						}
					});
				});
			},
			addInfo: function() {
				this.showTitle = "新增广告";
				this.dialogAddShow = true;
				this.mid = 0;
			},
			//显示编辑界面
			editInfo: function(index, row) {
				this.showTitle = "编辑广告";
				this.dialogAddShow = true;
				this.mid = row.id;
			},
			saveCallBack: function() {
				this.dialogAddShow = false;
				if (this.mid == 0) {
					this.handleCurrentChange(1);
				} else {
					this.getGridData();
				}
			},
			closeDialog: function(bool) {
				this.dialogAddShow = bool
			},
			selectGridChange: function(sels) {
				this.sels = sels;
			}
		},
		mounted() {
			this.getGridData();
		}
	}
</script>


